import React, { useState } from "react";
import { sidebarLinks } from "../../../data/dashboard-links";
import { logout } from "../../../services/operations/authAPI";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import SidebarLink from "./SidebarLink";
import { VscSignOut } from "react-icons/vsc";
import ConfirmationModal from "../../common/ConfirmationModal";

function Sidebar(props) {
  const { user, loading: profileLoading } = useSelector(
    (state) => state.profile
  );
  const { loading: authLoading } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [confirmationModal, setConfirmationModal] = useState(null);
  const [sidebarVisible, setSidebarVisible] = useState(false);

  if (profileLoading || authLoading) {
    return <div className='flex w-full h-screen justify-center items-center'>
      <div className='spinner'></div>
    </div> 
    
    // <div className="spinner mt-20 flex justify-center items-center"></div>;
  }

  const toggleSidebar = () => {
    setSidebarVisible(!sidebarVisible);
  };

  return (
    <>
    <div className="relative flex">
      {/* Hamburger button to toggle the sidebar on small screens */}
      <button
        className="lg:hidden fixed top-4 left-1 z-50 p-2 text-richblack-50 mt-10 font-bold text-xl"
        onClick={toggleSidebar}>
        ☰
      </button>

      {/* Sidebar content */}
      <div
        className={`${
          sidebarVisible ? "block absolute z-10" : "hidden"
        } lg:flex lg:flex-col min-w-[12rem] max-[450px]:min-w-[4rem] border-r-[1px] border-richblack-700
        h-[calc(100vh-3.5rem)] bg-richblack-700 py-10`}>
        <div className="flex flex-col">
          {sidebarLinks.map((link) => {
            if (link.type && user?.accountType !== link.type) {
              return null;
            }
            return (
              <SidebarLink key={link.id} link={link} iconName={link.icon} />
            );
          })}
        </div>
        <div className="mx-auto mt-6 mb-6 h-[1px] w-10/12 bg-richblack-600"></div>
        <div className="flex flex-col ">
          <SidebarLink
            link={{ name: "Settings", path: "dashboard/settings" }}
            iconName="VscSettingsGear"
          />
          <button
            onClick={() => {
              setConfirmationModal({
                text1: "Are you sure?",
                text2: "You will be logged out of your account",
                btn1Text: "Logout",
                btn2Text: "Cancel",
                btn1Handler: () => {
                  dispatch(logout(navigate));
                },
                btn2Handler: () => {
                  setConfirmationModal(null);
                }, // to make modal invisible
              });
            }}
            className="text-sm font-medium text-richblack-300">
            <span className="flex px-8 py-2 items-center text-richblack-25 gap-x-2 cursor-pointer">
              <VscSignOut className="text-lg" />
              Logout
            </span>
          </button>
        </div>
      </div>

    </div>
      {/* Confirmation modal */}
      <div >
        {confirmationModal && (
          <ConfirmationModal modalData={confirmationModal} />
        )}
      </div>
      </>
  );
}

export default Sidebar;
